<!--
 * @Description:
 * @Author: 诺
 * @Date: 2021-12-19 14:19:13
 * @LastEditors: 诺
 * @LastEditTime: 2023-04-10 10:27:53
-->
<template>
  <div
    id="boxMian"
    v-if="configInfo"
    class="boxMian"
    :style="{
      backgroundColor: configInfo.backgroundColour,
    }"
  >
    <div class="page-wrapper" :style="{ backgroundImage: `url('${configInfo.backgroundImg}')` }">
      <div class="logo"><img :src="configInfo.topLogoImg" /></div>
      <ActBaseTotalShow :sVisit="configInfo.watchShowSwitch" :visitTotal="visitTotal" :sJoin="configInfo.joinShowSwitch" :joinTotal="joinTotal" />
      <div class="kv"><img :src="configInfo.mainKvImg" /></div>

      <div
        class="ruleBtn act-text-stroke"
        :style="{
          backgroundColor: configInfo.buttonBackgroundColour,
          color: configInfo.buttonTextColour,
        }"
        @click.stop="handle('rule')"
      >
        游戏规则
      </div>

      <div class="btn">
        <div class="hexagonBtn" @click.stop="handle('ranking')">
          <div class="btn-box">
            <div class="btn-box--inner" :style="{ backgroundColor: configInfo.buttonBackgroundColour }">
              <img src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/rankingIcon.png" />
              <span class="act-text-stroke text">排行</span>
            </div>
          </div>
        </div>
        <div class="gameTime act-text-stroke" :style="{ color: configInfo.buttonTextColour }">
          <div>距活动结束还剩</div>
          <div class="countDown">
            <template v-if="day > 0">
              <div class="time" :style="{ backgroundColor: configInfo.mainColour,}">{{ day }}</div>天
            </template>
            <div class="time" :style="{ backgroundColor: configInfo.mainColour, }">{{ hour }}</div>时
            <div class="time" :style="{ backgroundColor: configInfo.mainColour, }" >{{ minute }}</div>分
            <template v-if="day <= 0"> 
              <div class="time" :style="{ backgroundColor: configInfo.mainColour, }" >{{ second }}</div>秒
            </template>
          </div>
        </div>
        <div class="hexagonBtn" @click.stop="handle('prize')">
          <div class="btn-box">
            <div class="btn-box--inner" :style="{ backgroundColor: configInfo.buttonBackgroundColour }">
              <img src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/prize-icon.png" />
              <span class="act-text-stroke text">奖品</span>
            </div>
          </div>
        </div>
      </div>

      <div class="winsBox" v-if="configInfo.rotationWinSwitch == 1 && winUser.length >= 3" :style="{ backgroundColor: `${rgba(configInfo.mainColour, 0.3)}` }">
        <BaseRollWins :wins="winUser"></BaseRollWins>
      </div>

      <template v-for="(item) in configInfo.sortModuleSwitch?configInfo.sortModuleList:configInfo.defaultSortModuleList" >
        <template v-if="item.type=='prize'" >
          <BasePrizeList :data="prizeList" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" :title="configInfo.prizeTitle" />
        </template>
        <template v-if="item.type=='ranking'" >
          <ActBaseRankingList :data="rankingList" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" :title="configInfo.rankPrizeTitle"  :theme="`theme${configInfo.modelType}`"/>
        </template>
        <template v-if="item.type=='coupon'" >
          <ActBaseCouponList type='lightup' :data="couponList" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" :title="configInfo.couponTitle" @handleCoupon="handleCoupon" />
        </template>
        <template v-if="item.type=='prizePool'" >
          <BasePrizepoolConfig v-if="configInfo.bonusSwitch == 1" :title="configInfo.prizepool" :completedNum="completedNum" :bonusShowAmount="configInfo.bonusShowAmount / 100" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" />
        </template>
        <template v-if="item.type=='custom'" >
          <ActBaseCustomModule type="lightup" v-if="configInfo.customModuleSwitch" :data="configInfo.customModuleList" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" :title="configInfo.customTitle2" @upData="getInfoList"/>
        </template>
        <template v-if="item.type=='project'" >
          <ActBaseProjectList type="lightup" v-if="configInfo.salesSiteShowSwitch == 1" :data="projectList" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" :title="configInfo.salesSiteTitle"  :salePhone="salePhone"/>
        </template>
        <template v-if="item.type=='wxWork'||item.type=='WxWork'" >
          <ActBaseWxWork :data="wxWorkImg" v-if="configInfo.wxWorkSwitch == 1 && wxWorkImg" type="lightup" :bColor="configInfo.mainColour" :textColor="configInfo.buttonTextColour" :title="configInfo.wxWorkTitle" :tip="configInfo.wxWorkTip" />
        </template>
      </template>

      <BaseBottom :configInfo="configInfo" :showShareBtn="showShareBtn" @showShare="showShare" @lightup="handle" />
    </div>
    <!-- <img :class="['tipImg', { fadeOut: !showTip && !showClickTip, 'animate-top': showTip, 'animate-click': showClickTip }]" src="https://assets.rurushishi.com/activies/activityCenter/turntableLottery/tip.png" /> -->
  </div>
</template>

<script>
import Vue from "vue/dist/vue.js";
import soundBuffer from "@/utils/sound";
import request from "@/http/common";
import apiActWxauth from "@/api/act-wxauth";
import util from "./../../utils/common";

const statusTipMap = {
  0: "该活动无效",
  1: "该活动待发布",
  2: "该活动未上线",
  4: "该活动已暂停",
  5: "该活动已结束",
  6: "活动未开始",
};

export default {
  components: {
    // RushiSlide,
    // TotalShow,
    // BgMusic,
    // TurntableMain,
    // CouponList,
    // RankingList,
    // PrizeList,
    // ProjectList,
    // RollWins,
  },
  props: {},
  data() {
    return {
      configInfo: null, //配置信息
      actInfo: {}, //活动信息
      helpText: "点亮值",
      winUser: [],
      joinTotal: 0,
      visitTotal: 0,
      btnList: [
        { type: "rule", text: "游戏规则" },
        { type: "prize", text: "我的奖品" },
        { type: "ranking", text: "排行榜" },
      ],
      rotateAngle: "", //将要旋转的角度
      prizeList: [],
      rotateType: 0, // 默认为 0  转盘转动
      randCircle: 4, // 附加多转几圈，2-3
      duringTime: 5, //转盘持续时间
      rotateNum: 1, //抽奖操作的次数

      isClick: true, // 点击抽奖
      gameCount: 0, // 游戏次数

      couponList: [],
      rankingList: [],
      projectList: [],
      latitude: "",
      longitude: "",
      notInArea: false,

      // remainingTime:0,
      day: "00",
      hour: "00",
      minute: "00",
      second: "00",
      showShareBtn: true,
      showTip: true,
      showClickTip: false,

      assistanceNumber: 0,
      assistanceList: [],
      ranking: [],
      progressWidth: 0,
      prizeInfo: {},
      myPrizeList: [],
      isReceive: true,
      completedNum: 0,
      soundBuf: null,
      wxWorkImg: "",
      isUpSdk: false,
      salePhone:'',
      myPrizeCodeList:[]
    };
  },

  filters: {
    filterName: function (name) {
      if (name == null) {
        return name + "***";
      } else if (name && name.length >= 1) {
        return name.slice(0, 2) + "***";
      } else {
        return name + "***";
      }
    },
    // formatTime(val){
    //   var _totalSecond = Math.ceil(val / 1000);
    //   var _day = Math.floor(_totalSecond / (24 * 60 * 60));
    //   var _hour = Math.floor((_totalSecond % (24 * 60 * 60)) / (60 * 60));
    //   var _minute = Math.floor(((_totalSecond % (24 * 60 * 60)) % (60 * 60)) / 60);
    //   console.log(_day,_hour,_minute,_second)
    //   return ;
    // }
  },
  watch: {},
  computed: {
    progressStyle() {
      const { buttonBackgroundColour } = this.configInfo;
      return {
        background: `linear-gradient(90deg, #21FFF0 0%, ${buttonBackgroundColour} 100%)`,
      };
    },
    progressBgStyle() {
      const { mainColour } = this.configInfo;
      return {
        background: `linear-gradient(180deg, ${mainColour} 0%, rgba(255, 255, 255, 0.6) 100%)`,
      };
    },
  },
  mounted() {
    console.log(this.$actCode);
    this.$wx.ready(() => {
      this.initAct();

      // this.$nextTick(() => {
      //   // document.getElementById("boxMian").addEventListener("scroll", this.handleScroll);
      //   window.addEventListener("scroll", this.handleScroll);
      // });
    });

    // 监听分享回调事件
    this.$wx.shareCallBackFunList.push("share1", () => {
      if (!this.handleGameStatus()) {
        return;
      }
      let url = this.$apizt.action.share;
      this.$httpzt.requestRestFul(url, {});
      this.$modal.share.close();
      // this.getGameNum();
    });

    // setTimeout(()=>{this.showTip=false},2000)
  },
  methods: {
    rgba(color, alp) {
      return util.rgbToRgba(color, alp);
    },
    handleScroll() {
      // let scrollTop = document.getElementById("boxMian").scrollTop;
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      // console.log(scrollTop)
      if (scrollTop > window.innerHeight / 10) {
        this.showShareBtn = true;
      } else {
        this.showShareBtn = false;
      }
    },
    async getSaleByOpenId() {
      let url = this.$apizt.action.getSaleByOpenId.api + `/${this.$openid}/${this.configInfo.projectId}`;
      let shareLink = "";
      let fromSaleOpenId = this.$fromSaleOpenId;
      await this.$httpdf.get(url, null).then((data) => {
        if (data.code == 200 && data.data) {
          fromSaleOpenId = this.$openid;
          this.$fromSaleOpenId = this.$openid;
        }
        let appinfo = `&fuserId=${this.$fuserId}&fcorpId=${this.$fcorpId}`;
        if (this.$util.browser.versions.wxwork) {
          appinfo = `&fuserId=${this.$userId}&fcorpId=${this.$corpId}`;
        }
        if (this.$avoidWeChatBug == 1) {
          shareLink = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}&actCode=${this.$actCode}&fromSaleOpenId=${fromSaleOpenId}${appinfo}&avoidWeChatBug=0`;
        } else {
          shareLink = `${this.$site}#/index?channel=${this.$channel}&fopenid=${this.$openid}&actCode=${this.$actCode}&fromSaleOpenId=${fromSaleOpenId}${appinfo}&avoidWeChatBug=1`;
        }
        const { shareTitle, shareInfo, shareSmallImg } = this.configInfo;
        if (this.$util.browser.versions.wxwork) {
          this.$wx.upWxWorkShare(shareTitle, shareInfo, shareLink, shareSmallImg);
        } else {
          this.$wx.upShare(shareTitle, shareInfo, shareLink, shareSmallImg);
        }
        const _self=this;
        this.$wx.sdk.miniProgram.getEnv(function(res) {
          console.log(res.miniprogram,'res.miniprogram') // true
          if(res.miniprogram){
            const locationUrl = new URL(window.location);
            locationUrl.searchParams.set('gzhOpenId', _self.$openid);
            locationUrl.searchParams.set('actCode', _self.$actCode);
            locationUrl.searchParams.set('customFlag', 0);
            locationUrl.searchParams.set('shareTitle', shareTitle);
            locationUrl.searchParams.set('shareImg', shareSmallImg);
            locationUrl.searchParams.set('shareUrl', (shareLink));
            window.history.pushState({}, '', locationUrl);
          }
        })
        this.$util.cookie.set("shareLink", shareLink, {
          expires: 30,
        });
      });
    },
    async getSaleInfo() {
      let url = this.$apizt.action.getSaleByOpenId.api + `/${this.$fromSaleOpenId}/${this.configInfo.projectId}`;
      
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if(data){
        this.salePhone=data.phone
      }
    },
    // 页面配置
    async initAct() {
      this.$showLoading();
      // let url = this.$apizt.action.getConfig;
      // const { data, result } = await this.$httpzt.requestRestFul(url, {});
      // if (result) {
      //   this.configInfo = {
      //     // ...data,
      //     // receiveAddress:data.receiveAddress,
      //     // status:data.status,
      //     ...data,
      //     uiExt: "",
      //     ...JSON.parse(data.uiExt),
      //   };

      //   document.title = data.actName;
      //   const cookieConfig = { ...this.configInfo, actRule: "" };
      //   console.log(cookieConfig);
      //   this.$util.cookie.set("configInfo", JSON.stringify(cookieConfig), {
      //     expires: 30,
      //   });
      if (this.$configInfo.clueIncrementEnable && this.$openid) {
        const { data } = await this.getUserInfo(this.$openid)
        let userInfo = data.data;
        const hYparams = {
          firstname: '',
          email: '',
          mobile: '',
          company: '',
          position: '',
          utm_source: this.$configInfo.projectId,

          wechat_type: "wechat" ,
          wechat_pubid : this.$configInfo.appId || '',
          wechat_pubname : '',
          wechat_openid: this.$openid || '',
          wechat_nickname: userInfo.nickname || '',
          wechat_facelogo: userInfo.avatarUrl || '',
          wechat_province: '',
          wechat_city: '',
          wechat_ip: '',
        };
        console.log('火眼云统计参数===>', hYparams);
        window.hymk('send','pageview',hYparams);
      }
      console.log('===>', this.$configInfo);

      this.configInfo = this.$configInfo;

      document.title = this.$configInfo.actName;
      if (this.configInfo.helpType == 2) {
        this.helpText = this.configInfo.helpText;
      }
      Vue.prototype.$projectId = this.configInfo.projectId;

      // endTime
      this.remainingTime = Math.ceil((this.configInfo.endTime - new Date().getTime()) / 1000); // 剩余多少秒 活动倒计时
      if (this.remainingTime > 0) {
        setInterval(() => {
          this.remainingTime--;
          this.countDown();
        }, 1000);
      }
      if (this.configInfo.status == 3 && this.configInfo.startTime > new Date().getTime()) {
        this.configInfo.status = 6;
      }
      this.$status = this.configInfo.status;
      if (this.configInfo.rankPrizeSwitch == 1) {
        this.getRankPrize();
      }
      if (this.configInfo.couponSwitch == 1) {
        this.getCouponPrize();
      }
      if (this.configInfo.bonusSwitch == 1) {
        this.getAccomplishLightCount();
      }
      this.getCounts();
      this.getPrizeList();
      // if (data.salesSiteShowSwitch == 1) {
      // this.initRanking();
      // }
      if(this.$fromSaleOpenId){
       await this.getSaleInfo()
      }

      await this.getProjectList();
      
      this.homePrizeLogs();
      if(this.$isSnapshotUser==1){
        return 
      }
      if (this.configInfo.shareSwitch == 1) {
        await this.getSaleByOpenId();
      } else {
        this.$wx.hideOptionMenu();
      }

      if (this.configInfo.bizType == 4) {
        await this.getWxWorkImg();
      } else if (this.configInfo.wxWorkSwitch) {
        this.wxWorkImg = this.configInfo.wxWorkImg;
        this.$util.cookie.set("wxWorkImg", this.wxWorkImg, {
          expires: 30,
        });
        if (this.configInfo.wxWorkSalesSwitch == 1) {
          await this.getUserWxWorkImgStandard();
        }
      }
      if (!this.$openid) {
        return;
      }
      this.getInfoList();
      if (this.handleGameStatus()) {
        // this.getGps();
        this.participation();
      } else {
        this.isReceive = false;
        this.$showToast(statusTipMap[this.configInfo.status]);
      }
      // }
    },

    getUserInfo(openid) {
      // 获取当前用户信息
      return new Promise((resolve, reject) => {
        let url = `${apiActWxauth.protocol}//${apiActWxauth.domain}${apiActWxauth.action.getUserInfo}/${openid}`;
        request
          .get(url, {})
          .then(function (res) {
            let temp = res.data.data;
            if (temp) {
              // window._paq.push(['setUserId',temp.nickName+'_'+temp.openId+'_'+temp.province+'_'+temp.city])
            }
            resolve(res);
          })
          .catch((res) => {
            reject(res);
          });
      });
    },

    countDown(time) {
      // let _totalSecond = Math.ceil(this.remainingTime / 1000);
      let _totalSecond = Math.ceil(this.remainingTime);
      let day = Math.floor(_totalSecond / (24 * 60 * 60));
      let hour = Math.floor((_totalSecond % (24 * 60 * 60)) / (60 * 60));
      let minute = Math.floor(((_totalSecond % (24 * 60 * 60)) % (60 * 60)) / 60);
      let second = Math.floor(((_totalSecond % (24 * 60 * 60)) % (60 * 60)) % 60);

      if (day < 10) {
        day = "0" + day;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      this.$nextTick(() => {
        this.day = day;
        this.hour = hour;
        this.minute = minute;
        this.second = second;
      });
    },
    // 首页浏览围观
    async getCounts() {
      let url = this.$apizt.action.counts;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.joinTotal = data.participates || 0;
        this.visitTotal = data.onlooker || 0;
      }
    },
    async getInfoList() {
      let url = this.$apizt.action.infoList;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      let listUrl = this.$apizt.action.signUpUserList;
      const res = await this.$httpzt.requestRestFul(listUrl, {actCode:this.$actCode,pageNo:1,pageSize:50});
      const list=res.data.records
      if (result) {
        this.configInfo.customModuleList=this.configInfo.customModuleList.map((item,index)=>{
        let obj=data.filter(v=>v.sort==index)
        if(item.addType=='sign'){
            let k=list.filter(j=>j.prizeCode==obj[0].code)
            item={
              ...item,
              ...obj[0],
              signList:k
            }
          }
          console.log(item)
          return item
        })
        console.log(this.configInfo.customModuleList)
      }
    },
    // 获取活动活码
    async getWxWorkImg() {
      let url = this.$apizt.action.getWeChatQrCode;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        console.log(data);
        if (data) {
          this.wxWorkImg = data.homePage;
          this.$util.cookie.set("homePage", data.homePage, {
            expires: 30,
          });
          this.$util.cookie.set("receivePrizePage", data.receivePrizePage, {
            expires: 30,
          });
        }else{
          this.$util.cookie.remove("homePage");
          this.$util.cookie.remove("receivePrizePage");
        }
        if (this.configInfo.salesShareSwitch == 1) {
          this.getUserWxWorkImg();
        }
      }
    },
    // 获取销售活码
    async getUserWxWorkImg() {
      let openid = this.$fromSaleOpenId;
      console.log(openid, " openid");
      let url = this.$apizt.action.getSalesWeChatQrCode.api + `?openId=${openid}`;
      const { data, result } = await this.$httpzt.requestRestFul(url, {}, "post");
      if (result) {
        console.log(data);
        if (data) {
          this.wxWorkImg = data.homePage;
          this.$util.cookie.set("homePage", data.homePage, {
            expires: 30,
          });
          this.$util.cookie.set("receivePrizePage", data.receivePrizePage, {
            expires: 30,
          });
        }
      }
    },
    // 获取销售活码
    async getUserWxWorkImgStandard() {
      const _self = this;
      const passport = this.$util.cookie.get("passport");
      const openid = this.$util.cookie.get("openid");
      let corpId = _self.$corpId || _self.$fcorpId;
      let userId = _self.$userId || _self.$fuserId;
      console.log(corpId, userId, "corpIdcorpId");
      if (!corpId || !userId || !openid || !passport) {
        return;
      }
      let url = `${process.env.VUE_APP_WXWORK_API}${apiActWxauth.action.wxWorkGetUserInfoImg}`;
      request
        .get(
          url,
          {
            appid: apiActWxauth.appid,
            corpId: corpId,
            userId: userId,
            accountType: "qywx",
          },
          {
            openid: openid,
            passport: passport,
          }
        )
        .then(function (res) {
          console.log(res);
          _self.wxWorkImg = res.data.data.qrCode;
          _self.$util.cookie.set("wxWorkImg", _self.wxWorkImg, {
            expires: 30,
          });
        });
    },
    // 中奖信息
    async homePrizeLogs() {
      let url = this.$apizt.action.homePrizeLogs;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.winUser = data;
      }
    },
    // 获取点亮人数
    async getAccomplishLightCount() {
      let url = this.$apizt.action.accomplishLightCount;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.completedNum = data;
      }
    },
    // 获取排行奖品
    async getRankPrize() {
      let url = this.$apizt.action.getRankPrize;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.rankingList = data;
      }
    },
    // // 获取排行榜
    // async initRanking() {
    //   let param = this.$apizt.action.getAssistanceRank;
    //   const { data, result } = await this.$httpzt.requestRestFul(param, {
    //     actCode: this.$actCode,
    //     size: 50,
    //   });
    //   if (result) {
    //     this.ranking = data;
    //   }
    // },
    async getMyprize() {
      let param = this.$apizt.action.getReceivePrizeCode;
      const { data, result } = await this.$httpzt.requestRestFul(param, {});
      if (result) {
        let myPrizeList = [];
        let prizeCode = data || [];
        this.couponList.map((item) => {
          if (prizeCode.indexOf(item.code) > -1) {
            item.isReceive = true;
            myPrizeList.push(item);
          }
        });
        this.myPrizeList = myPrizeList;
      }
    },
    // 获取助力奖品
    async getPrizeList() {
      let url = this.$apizt.action.prizeList;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        // console.log(data);
        this.prizeList = data;
        let assistanceList = data.map((item) => {
          return item.requireLevel;
        });
        this.assistanceList = assistanceList.filter((item) => {
          return item > 0;
        });
      }
    },
    // 获取优惠券
    async getCouponPrize() {
      let url = this.$apizt.action.getCouponPrize;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        this.couponList = data;
      }
    },
    // 获取项目列表
    async getProjectList() {
      // let url = this.$apizt.action.getProjectList.api+`?actCode=${this.$actCode}`;
      let url = this.$apizt.action.getProjectList;
      const { data, result } = await this.$httpzt.requestRestFul(
        url,
        {
          actCode: this.$actCode,
        },
        "post"
      );
      if (result) {
        this.projectList = data;
      }
    },

    // 参与活动
    async participation() {
      console.log(this.$util.systemInfo);
      const _self = this;
      let url = this.$apizt.action.participation;
      let params = {
        deviceBrand: this.$util.systemInfo.vendor,
        deviceModel: this.$util.systemInfo.model,
        latitude: this.latitude,
        longitude: this.longitude,
      };
      const { data, code, result } = await this.$httpzt.requestRestFul(url, params);
      if (code == 9997) {
        console.log(data);
        if (this.configInfo.gpsSwitch == 1) {
          this.getGps();
        } else {
          _self.upSdkInit()
          this.$showToast("这个活动离您有点远，本次可能无法玩耍呦!", "提示");
        }
        return;
      }
      if (code == 8886) {
        _self.upSdkInit()
        this.notInArea = true;
        this.$showToast("这个活动离您有点远，本次可能无法玩耍呦!", "提示");
        return 
      }
      
      if (code == 200) {
        Vue.prototype.$userInfo = data.user;
        if(data.user.mobile){
          sessionStorage.setItem("mobile", data.user.mobile);
        }
        // if(data.assistanceResultCode&&[200,8890,8891].includes(data.assistanceResultCode)){
          if(data.receiveKey&& this.$fopenid && this.$fopenid !== this.$openid){
            this.$modal.form.alert({
              type: "helpPrize",
              code: data.receiveKey,
              prizeName: "随机惊喜",
              receiveKey: data.receiveKey,
              prizeType: 1,
              deadline: data.deadline,
            }).then((result) => {
                if (result == "success") {
                  let data = this.$luck.getData(this.$actCode);
                  data.redpacket = true;
                  this.$luck.setData(this.$actCode, data);
                }
                this.getMyprize();
              });
          }else if(data.assistanceResultCode==200){
            this.$showToast("您已为好友成功助力!", "提示");
          }
        // }
        if(data.assistanceResultCode==8883){
          this.$showToast("助力达到当前上限!", "提示");
        }
      }
      // if (code == 8883) {
      //   this.$showToast("助力达到当前上限", "提示");
      // }
      
      // if(code==8891){
      //   const isPop= this.$util.cookie.get(`isPop`)&&JSON.parse(this.$util.cookie.get(`isPop`))
      //   const value=`${this.$actCode}${this.$fopenid}`
      //   if(!isPop||!isPop.includes(value)){
      //     let cook=(isPop?isPop.concat(value):[value])
      //     this.$util.cookie.set(`isPop`, cook, { expires: 30 });
      //     this.$showToast("助力失败，该用户无法获得助力。", "提示");
      //   }
      // }
      _self.upSdkInit()
      _self.getAssistanceNumber()
      this.notInArea = false;
      // this.getReceivePrizeList();
    },
    getGps() {
      const _self = this;
      if (location.host.indexOf("localhost") > -1) {
        _self.latitude = 36.126893;
        _self.longitude = 115.980884;
        _self.participation(); // 获取
        return;
      }
      _self.$wx.ready(() => {
        _self.$wx.getLocation().then((res) => {
          console.log(res);
          if (res.errMsg == "getLocation:ok") {
            const latitude = res.latitude; //纬度，范围为 -90~90，负数表示南纬
            const longitude = res.longitude; //经度，范围为 -180~180，负数表示西经
            _self.latitude = latitude;
            _self.longitude = longitude;
            _self.participation();
          } else {
            this.notInArea = true;
            this.$showToast("这个活动离您有点远，本次可能无法玩耍呦!", "提示");
            _self.upSdkInit();
          }
        });
      });
    },
    upSdkInit() {
      if (!this.isUpSdk) {
        this.isUpSdk = true;
        this.$wx.isNeedUpdate();
      }
    },
    async getReceivePrizeList() {
      let url = this.$apizt.action.getReceivePrizeList;
      const { data, result } = await this.$httpzt.requestRestFul(url, {});
      if (result) {
        console.log(data);
        this.myPrizeCodeList=data.map(item=>{return item.prizeCode})
      }
    },
    // async getGameNum() {
    //   if (!this.handleGameStatus()) {
    //     return this.$showToast(statusTipMap[this.configInfo.status]);
    //   }
    //   let url = this.$apizt.action.getGameNum;
    //   const { data, result } = await this.$httpzt.requestRestFul(url, {});
    //   if (result) {
    //     this.gameCount = data;
    //   }
    // },

    // 获取当前用户助力
    async getAssistanceNumber() {
      let url = this.$apizt.action.getAssistanceNumber;
      let { data, result } = await this.$httpzt.requestRestFul(url, {}, "get");
      if (result) {
        this.assistanceNumber = data;
      }
    },
    async handleCoupon(item) {
      // 优惠券
      if (!this.handleGameStatus()) {
        return this.$showToast(statusTipMap[this.configInfo.status]);
      }
      if (this.notInArea) {
        return this.$showToast("这个活动离您有点远，本次可能无法玩耍呦!", "提示");
      }
      console.log(item);
      let receiveKey = item.code;
      if (item.isReceive) {
        return this.$showToast("已经购买或锁定过当前优惠券了!", "提示");
      }
      if(this.assistanceNumber<item.requireLevel){
        return this.$showToast(`您还需要${item.requireLevel-this.assistanceNumber}个助力值才可领取`, "提示");
      }
      let isReceive=false;
      let url = this.$apizt.action.checkWinCondition;
      const { data, result } = await this.$httpzt.requestRestFul(url, {prizeCodeList:[item.code]});
      if (result) {
        if(!data.includes(item.code)){
          isReceive=true
        }
      }
      if(isReceive){
        return this.$showToast("不要贪心哦，您的礼品额度已用完，欢迎邀请朋友参与哦!", "提示");
      }
      
      if (item.winType == 5) {
        let url = this.$apizt.action.lockCoupon.api;
        const { data, result } = await this.$httpzt.requestRestFul(`${url}${item.code}`, {}, "post");
        if (result) {
          receiveKey = data;
        } else {
          return;
        }
      }
      this.$modal.form.alert({
        type: item.winType == 5 ? "key" : "code",
        prizeType: 2,
        code: item.code,
        prizeName: item.name,
        receiveKey: receiveKey,
        winType: item.winType,
      });
    },
    handle(type) {
      if (type == "rule") {
        this.$router.push({
          path: `/${type}`,
          query: this.$route.query,
        });
        return;
      }
      if (!this.handleGameStatus() && this.configInfo.status != 5) {
        return this.$showToast(statusTipMap[this.configInfo.status]);
      }
      if (this.notInArea) {
        return this.$showToast("这个活动离您有点远，本次可能无法玩耍呦!", "提示");
      }
      this.$router.push({
        path: `/${type}`,
        query: this.$route.query,
      });
    },
    handleGameStatus() {
      return this.configInfo.status == 3;
    },
    showShare() {
      let text = {
        text1: "点击",
        text2: "右上角",
        text3: "推荐好友参与",
        text4: "让你和TA都获得金喜，",
        text5: "快去消息列表看看",
        text6: "会有什么神奇的事情发生吧！",
      };
      // if (this.configInfo.helpOnOrOff == 1) {
      //   text.text2 = `每日分享好友，最多获得${this.configInfo.helpTimesUpperLimit}次机会，`;
      //   let helpRule = JSON.parse(this.configInfo.helpRule);
      //   text.text3 = `每助力${helpRule.helpTimes}人，可获得${helpRule.getLotteryTimeWithHelp}次机会。`;
      // }
      this.$modal.share.alert(text).then((data) => {
        if (data == "save") {
          console.log(this.configInfo.shareImg);
          this.$modal.poster.alert({
            gameBg: this.configInfo.shareImg, //分享截图背景图
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
div {
  position: relative;
  box-sizing: border-box;

  img {
    width: 100%;
  }
}

.boxMian {
  width: 100%;

  .page-wrapper {
    position: relative;
    width: 100%;
    overflow-x: hidden;
    background-position: top center;
    background-repeat: no-repeat;
    background-size: 100% auto;
    padding-bottom: 120px;

    .logo {
      width: 343px;
      margin: 16px auto 0;
    }

    .kv {
      width: 375px;
      text-align: center;
      margin: 8px auto 0;
    }

    .buttonList {
      position: absolute;
      top: 80px;
      right: 0;
      // width: 58px;
      z-index: 99;

      .operation-item {
        // width: 58px;
        height: 24px;
        border-radius: 12px 0 0 12px;
        font-size: 11px;
        text-align: center;
        line-height: 24px;
        margin-bottom: 14px;
        // padding-left: 3px;
        padding: 0 3px 0 6px;
      }
    }

    .ruleBtn {
      position: absolute;
      top: 80px;
      width: 23px;
      height: 72px;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      writing-mode: vertical-lr;
      font-size: 11px;
      border-radius: 6px 0px 0px 6px;
      border: solid #fff;
      border-width: 1px 0 1px 1px;
    }

    .btn {
      display: flex;
      align-items: center;
      justify-content: center;
      .hexagonBtn {
        display: flex;
        align-items: center;
        justify-content: center;

        .btn-box {
          width: 52px;
          height: 44px;
          background: #fff;
          clip-path: polygon(25% 0, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0 50%);
          transition: 1s clip-path;
          display: flex;
          justify-content: center;
          align-items: center;
          &--inner {
            width: 50px;
            height: 42px;
            background: #ffb338;
            clip-path: polygon(25% 0, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0 50%);
            transition: 1s clip-path;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              width: 18px;
              height: auto;
              margin-bottom: 2px;
            }
            .text {
              color: #fff;
              font-size: 10px;
            }
          }
        }

        .box1 {
          border-right: 10px solid transparent;
          border-top: 23px solid transparent;
          border-bottom: 23px solid transparent;
        }
        .box2 {
          width: 30px;
          height: 46px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          display: none;
          img {
            width: 18px;
            margin-bottom: 4px;
          }
        }

        .box3 {
          width: 0;
          border-left: 10px solid transparent;
          border-top: 23px solid transparent;
          border-bottom: 23px solid transparent;
        }
      }
    }

    .gameTime {
      margin: 4px 30px 0;
      font-size: 12px;
      text-align: center;

      .countDown {
        font-size: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 8px;

        .time {
          width: 25px;
          height: 28px;
          border-radius: 4px;
          line-height: 28px;
          margin: 0 4px;
        }
      }
    }
  }
}

// .shareBtn {
//   width: 278px;
//   bottom: 50px;
//   left: 50%;
//   margin-left: -139px;
//   position: fixed;
//   z-index: 9;

//   .default {
//     width: 278px;
//     height: 48px;
//     box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
//     border-radius: 100px;
//     text-align: center;
//     line-height: 48px;
//     font-size: 20px;
//   }

//   .shareImg {
//     width: 278px;
//     height: 48px;

//     img {
//       width: 278px;
//       height: 48px;
//       object-fit: contain;
//     }
//   }
// }

.play-num,
.share-btn {
  width: 220px;
  height: 40px;
  line-height: 40px;
  font-size: 18px;
  color: #fff;
  margin: 10px auto 0;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
}

.share-btn {
  background: #fa3e3f;
}

.play-num {
  background: #ffb338;
}
.tipImg {
  position: fixed;
  bottom: 80px;
  right: 30%;
  width: 80px;
  pointer-events: none;
  // display: none;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  &.animate-top {
    animation-name: tip_animate;
  }
  &.animate-click {
    animation-name: click_animate;
    animation-timing-function: ease;
    animation-duration: 0.5;
  }
  &.fadeOut {
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

@keyframes tip_animate {
  from {
    transform: translateY(50px);
  }
  to {
    transform: translateY(-20px);
  }
}
@keyframes click_animate {
  0% {
    transform: rotate(-15deg);
  }
  40% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(15deg);
  }
}

.winsBox {
  width: 311px;
  height: 32px;
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  box-sizing: border-box;
  box-shadow: 0px 0px 12px rgba(172, 3, 40, 0.3);
  border-radius: 12px;
  margin: 20px auto 0;
}
.progressMain {
  position: relative;
  padding-top: 28px;

  .progressBox {
    position: relative;
    margin: 0 auto;
    margin-top: 20px;
    padding-bottom: 14px;
    width: 320px;
    .progressBg {
      position: relative;
      width: 320px;
      height: 14px;
      border-radius: 9px;
      padding: 2px;
      // overflow: hidden;
      .progress {
        width: 0px;
        height: 10px;
        border-radius: 5px;
        // border: 1px solid rgba(0, 0, 0, 0.2);
        overflow: hidden;
        img {
          position: absolute;
          top: 2px;
          height: 2px;
          width: 320px;
        }
      }
      .progressTip {
        position: absolute;
        width: 42px;
        height: 20px;
        top: -3px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        border-radius: 20px;
        font-size: 14px;
        font-weight: bold;
        line-height: 20px;
        text-align: center;
        color: #ffffff;
        margin-left: -21px;
        z-index: 1;
      }
    }
  }

  .progressTip2 {
    position: absolute;
    width: 66px;
    height: 18px;
    border-radius: 4px;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
    color: #ffffff;
    transform: translateX(-50%);
    // margin-left: 21px;
    top: -28px;
    .jt {
      clip-path: polygon(0% 0, 100% 0%, 50% 100%);
      transition: 1s clip-path;
      width: 7px;
      height: 4px;
      margin-left: 50%;
      top: -1px;
      transform: translateX(-50%);
    }
  }
  .progressNum {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 10px;
    line-height: 10px;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    padding: 0 30px 0 2px;
    .numItem {
      flex: 1;
      flex-direction: column;
      display: flex;
      align-items: flex-end;
      .x {
        font-size: 4px;
        line-height: 10px;
        text-align: center;
        margin-bottom: 4px;
        color: rgba(255, 255, 255, 0.4);
      }
      .num {
        transform: translateX(40%);
      }
    }
  }
}
</style>
